import React from 'react';
import { BarChart3 } from 'lucide-react';
import { Panel, Empty, Badge } from './Primitives';
import { useFetch } from '../lib/hooks';
import { fmtUsd, fmtDate } from '../lib/api';

export function TodayTrading({ bot }) {
  const pnl = Number(bot?.today_pnl || 0);
  return (
    <div className="grid gap-4 sm:grid-cols-3" data-testid="today-trading">
      <div className="vj-card p-4"><div className="text-xs text-vj-grey">Today's Trading Amount</div><div className="font-mono text-lg mt-1 text-vj-gold" data-testid="today-trading-amount">{fmtUsd(bot?.today_trading_amount)}</div></div>
      <div className="vj-card p-4"><div className="text-xs text-vj-grey">Today's P&L</div><div className={`font-mono text-lg mt-1 ${pnl >= 0 ? 'text-vj-neon' : 'text-vj-red'}`} data-testid="today-trading-pnl">{pnl >= 0 ? '+' : ''}{fmtUsd(bot?.today_pnl)}</div></div>
      <div className="vj-card p-4"><div className="text-xs text-vj-grey">Trading Allocation</div><div className="font-mono text-lg mt-1" data-testid="today-trading-allocation">{fmtUsd(bot?.allocation)}</div></div>
    </div>
  );
}

export function TradingResults({ limit = 10 }) {
  const { data: rows } = useFetch('/trading/reports', [], 30000);
  return (
    <Panel title="Trading Results" testId="trading-results" action={<Badge tone="gold"><BarChart3 size={12} /> Posted by VEYJEX desk</Badge>}>
      {rows && rows.length ? (
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-vj-grey border-b border-border"><th className="py-2 font-medium">Date</th><th className="font-medium">Trading amount</th><th className="font-medium">P&L</th><th className="font-medium">Note</th></tr></thead>
          <tbody>{rows.slice(0, limit).map((r) => (
            <tr key={r.id} className="border-b border-border last:border-0" data-testid={`trading-result-${r.id}`}>
              <td className="py-2.5 text-xs text-vj-grey">{fmtDate(r.created_at)}</td>
              <td className="font-mono">{fmtUsd(r.trading_amount)}</td>
              <td className={`font-mono ${Number(r.pnl) >= 0 ? 'text-vj-neon' : 'text-vj-red'}`}>{Number(r.pnl) >= 0 ? '+' : ''}{fmtUsd(r.pnl)}</td>
              <td className="text-xs text-vj-grey">{r.note || '—'}</td>
            </tr>
          ))}</tbody>
        </table></div>
      ) : <Empty>No trading results posted yet.</Empty>}
    </Panel>
  );
}
